/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TradePlanDetailType } from './TradePlanDetailType';
import {
    TradePlanDetailTypeFromJSON,
    TradePlanDetailTypeFromJSONTyped,
    TradePlanDetailTypeToJSON,
} from './TradePlanDetailType';

/**
 * 
 * @export
 * @interface OptimizerDetail
 */
export interface OptimizerDetail {
    /**
     * 
     * @type {string}
     * @memberof OptimizerDetail
     */
    detailId: string;
    /**
     * 
     * @type {number}
     * @memberof OptimizerDetail
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof OptimizerDetail
     */
    pId?: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizerDetail
     */
    allocationType?: string;
    /**
     * 
     * @type {TradePlanDetailType}
     * @memberof OptimizerDetail
     */
    detailType: TradePlanDetailType;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof OptimizerDetail
     */
    detailJson: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof OptimizerDetail
     */
    createdAt: string;
}



/**
 * Check if a given object implements the OptimizerDetail interface.
 */
export function instanceOfOptimizerDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "detailId" in value;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "detailType" in value;
    isInstance = isInstance && "detailJson" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function OptimizerDetailFromJSON(json: any): OptimizerDetail {
    return OptimizerDetailFromJSONTyped(json, false);
}

export function OptimizerDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizerDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detailId': json['detail_id'],
        'optimizationId': json['optimization_id'],
        'pId': !exists(json, 'p_id') ? undefined : json['p_id'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : json['allocation_type'],
        'detailType': TradePlanDetailTypeFromJSON(json['detail_type']),
        'detailJson': json['detail_json'],
        'createdAt': json['created_at'],
    };
}

export function OptimizerDetailToJSON(value?: OptimizerDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail_id': value.detailId,
        'optimization_id': value.optimizationId,
        'p_id': value.pId,
        'allocation_type': value.allocationType,
        'detail_type': TradePlanDetailTypeToJSON(value.detailType),
        'detail_json': value.detailJson,
        'created_at': value.createdAt,
    };
}

